import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static values = {
        dataset: String
    };

    handleChange(event) {
        const datalist = document.getElementById(this.datasetValue);
        const options = Array.from(datalist.options);
        const value = event.target.value;

        if (options.some(option => option.value === value)) {
            this.submitForm();
        }
    }

    submitForm() {
        const form = this.element.closest('form');
        const formData = new FormData(form);
        const params = new URLSearchParams(formData);
        const url = `${window.location.pathname}?${params.toString()}`;
        window.location.href = url;
    }
}
